module.exports = __webpack_public_path__ + "static/media/distribution_history.be379c03.svg";